import 'font-awesome/css/font-awesome.css'
import Vue from 'vue'

import App from './App'

import './config/bootstrap'
import './config/cheetahGrid'
import './config/msgs'
import './config/axios'
import './config/mq'
import './config/jsonExcel'
import './config/veeValidate'
import './config/grid'
import './config/datePicker'
import './config/moment'
import './config/printPdf'
import './config/vueTableDynamic'
import './config/i18n'
import './config/vueEaseTable'
// import './config/vueMathjax'

import store from './config/store'
import router from './config/router'
import marqueeOverflow from './components/triggerManagement/tools/marqueeOverflow'

Vue.directive('marquee-overflow', marqueeOverflow)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')